import { render, staticRenderFns } from "./bus.vue?vue&type=template&id=3d54b76e&scoped=true&"
import script from "./bus.vue?vue&type=script&lang=js&"
export * from "./bus.vue?vue&type=script&lang=js&"
import style0 from "./bus.vue?vue&type=style&index=0&id=3d54b76e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d54b76e",
  null
  
)

export default component.exports